import React, { useContext, useEffect, useState } from 'react'

// Libs
import { where } from 'firebase/firestore'
import { size, sumBy } from 'lodash'
import { Link } from 'react-router-dom'

import { HandleModalContext } from '../../../../../layout/mainlayout/MainLayout'

// Components
import { BackNumber } from '../components/BackNumber'
import { ButtonSwitchHorse } from '../components/ButtonSwitchHorse'
import { TableBtn } from '../components/TableBtn'
import { TableName } from '../components/TableName'

// Hooks
import useToasterHelper from '../../../../../helpers/ToasterHelper'
import { useEventTrainers } from '../../../../../hooks/useEventTrainers'
import { useChatClient } from '../../../../messages/components/withStreamClient'

// Services
import FirestoreService from '../../../../../services/firestoreService'

// Helpers
import helpers from '../../../../../commonHelpers/helpers'
import { generateName, getUserFullName } from '../../../../../helpers/helpers'
import { getAllRiders } from '../../../../../helpers/riders'
import { getConvertedData } from '../../../../../models/interface.helper'

// Redux
import { selectedEvent } from '../../../../../store/events/eventsSlice'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import { organizerSliceAcs } from '../../../../../store/organizer/organizerSlice'
import { selectAllUsers } from '../../../../../store/users/usersSlice'

// Models
import { EventRegisteredUsersModel } from '../../../../../models/event-registered-users/event-registered-users.model'
import { RecipientModel } from '../../../../../models/recipients/recipients'
import { RiderTeamMemberModel } from '../../../../../models/rider-team-member/riderTeamMember.model'
import { UserDocumentModel } from '../../../../../models/user-documents/user-documents.model'

// Types
import { IRiderTeamMemberInterface } from '../../../../../models/rider-team-member/riderTeamMember.interface'
import { IRegisteredUser, IRider } from '../../../../../types/entryRider'

// Constants
import { CONST } from '../../../../../const/const'
import { MESSAGES_CONST } from '../../../../../const/messages-const'
import { MODAL_CONSTS } from '../../../../../const/modal-const'
import { PAYMENT_STATUS, PAYMENT_TYPE } from '../../../../../types/payment'
import { HORSE_NAME_DEFAULT } from '../../../../../models/registrations-by-day/registrationByDay.interface'
const COLLECTIONS = CONST.DATA.FIRESTORE.V01.COLLECTIONS

const UNKNOWN = 'Unknown'

export enum ETabId {
  entries,
  spectators,
  draft,
  classes,
  // checkIn,
}

interface ITab {
  tab: string
  id: ETabId
  disabled?: boolean
}
export const MANAGE_CLINIC_TABS: ITab[] = [
  { tab: 'Entries', id: ETabId.entries },
  { tab: 'Classes', id: ETabId.classes },
  { tab: 'Spectators', id: ETabId.spectators },
]

export const ALL_CLASSES = { value: 'all', label: 'All Classes' }

export enum EStatuses {
  all = 'All',
  good = 'Good',
  bad = 'Bad',
  scratched = 'Scratched',
  draft = 'Draft',
}
export const ALL_STATUSES = { value: EStatuses.all, label: EStatuses.all }

enum ESorts {
  none,
  rider,
  horse,
  back,
}

export const ridersWithDraft = (riders: IRider[], isDraft: boolean) => {
  return riders.filter((rider) => {
    const isDraftRider =
      (rider.paymentType === PAYMENT_TYPE.DEFAULT &&
        rider.paymentStatus === PAYMENT_TYPE.DEFAULT) ||
      rider.paymentStatus === PAYMENT_STATUS.PENDING

    return isDraft ? isDraftRider : !isDraftRider
  })
}

export const useManageClinicNOtherAdminTabNew = (eventId: string) => {
  const { eventTrainers } = useEventTrainers(eventId)

  const toastFunction = useToasterHelper()

  const handleModalContext = useContext(HandleModalContext)
  const { createChatEvent } = useChatClient()

  const { EventFees, EventQuestions } = useAppSelector(selectedEvent)
  const users = useAppSelector(selectAllUsers)

  const [ridersClasses, setRidersClasses] = useState<(typeof ALL_CLASSES)[]>([])
  const [activeTab, setActiveTab] = useState<ETabId>(ETabId.entries)
  const [activeClass, setActiveClass] = useState({ value: '', label: '' })
  const [activeStatus, setActiveStatus] = useState<{ value: string; label: string }>(ALL_STATUSES)
  const [filteredRiders, setFilteredRiders] = useState<IRider[]>([])
  const [draftRiders, setDraftRiders] = useState<IRider[]>([])
  const [allRiders, setAllRiders] = useState<IRider[]>([])
  const [searchNameValue, setSearchNameValue] = useState('')
  const [loading, setLoading] = useState(true)
  const [activeSortType, setActiveSortType] = useState<ESorts>(ESorts.none)

  const sortRidersByScratched = (riders: IRider[]): IRider[] => {
    return riders.sort((a, b) => {
      if (a.isScratched === b.isScratched) return 0
      return a.isScratched ? 1 : -1
    })
  }

  const onViewReceiptClick = async (
    recipientId: number | string | null | undefined,
    registrationId: number | string | null | undefined
  ) => {
    if (!recipientId || !registrationId) {
      return toastFunction.info({ message: MESSAGES_CONST.NO_RECIPIENT })
    }

    try {
      const docSnapshot = await FirestoreService.filterItems(
        CONST.DATA.FIRESTORE.V01.COLLECTIONS.RECIPIENT.NAME,
        [
          where(
            CONST.DATA.FIRESTORE.V01.COLLECTIONS.RECIPIENT.FIELDS.RECIPIENT_ID.KEY,
            '==',
            recipientId
          ),
          where(
            CONST.DATA.FIRESTORE.V01.COLLECTIONS.RECIPIENT.FIELDS.REGISTRATION_DOC_ID.KEY,
            '==',
            registrationId
          ),
        ],
        1
      )
      let recipient = RecipientModel.fromFirestoreDoc(docSnapshot.docs[0]).toObject()
      handleModalContext?.handleModal?.(true, MODAL_CONSTS.BILL_BRIEFE, {
        bill: recipient,
      })
    } catch (error) {
      console.error('error', error)
    }
  }

  const tableColumns = [
    {
      name: (
        <TableName
          title={'Back #'}
          isActive={activeSortType === ESorts.back}
          titleAdds={
            !searchNameValue.length &&
            activeStatus.value === ALL_STATUSES.value &&
            activeClass.value === ALL_CLASSES.value ? (
              <span
                onClick={() => {
                  handleModalContext?.handleModal(true, MODAL_CONSTS.AUTO_ASSIGN_MODAL, {
                    riders: ridersWithDraft(allRiders, false),
                    cb: (arrValues: number[]) => {
                      const newRiders = [...ridersWithDraft(allRiders, false)]
                      arrValues.forEach((num, i) => {
                        if (newRiders[i]) newRiders[i].backNumber = num
                      })
                      setFilteredRiders(newRiders)
                    },
                  })
                }}
                className={'text-[#122B4680] opacity-50 cursor-pointer hover:opacity-90'}
              >
                • Auto
              </span>
            ) : (
              <></>
            )
          }
          btnHandler={() => sortHandler('backNumber')}
        />
      ),
      cell: (row: IRider) => {
        if (
          (row.paymentType === PAYMENT_TYPE.DEFAULT &&
            row.paymentStatus === PAYMENT_TYPE.DEFAULT) ||
          row.paymentStatus === PAYMENT_STATUS.PENDING
        ) {
          return (
            <span
              className={
                'whitespace-nowrap text-center w-[40px] text-[14px] font-normal text-SeabiscuitDark200ThemeColor/60'
              }
            >
              Draft
            </span>
          )
        }
        return (
          <BackNumber
            id={row.id || ''}
            backNumber={row.backNumber}
            allRiders={ridersWithDraft(allRiders, false)}
            cbUpdate={(value) => {
              const newRiders = [...ridersWithDraft(allRiders, false)]
              const riderIndex = newRiders.findIndex((r) => r.id === row.id)
              newRiders[riderIndex].backNumber = value
              setFilteredRiders(newRiders)
            }}
          />
        )
      },
      width: '8%',
    },
    {
      name: (
        <TableName
          title={'Rider & Registrar'}
          isActive={activeSortType === ESorts.rider}
          btnHandler={() => sortHandler('riderName')}
        />
      ),
      cell: (row: IRider) => (
        <>
          <Link
            to={`${CONST.ROUTES.MANAGE.MANAGE_RIDER.URL}/${row?.userId}/${eventId}/${row?.registrationDocId}`}
            className="flex items-center gap-4 w-[300px] hover:opacity-70 transition-all "
          >
            <span className="p-[2px] bg-[#f6f7fb] my-2 flex items-center rounded-full justify-center shrink-0">
              <img
                alt="icons"
                onError={(e) =>
                  ((e.target as any).src =
                    `https://ui-avatars.com/api/?name=${helpers.generateName(row.riderName ?? UNKNOWN)}&background=FFFFFF&format=svg&bold=true&color=BCC6D5&rounded=true`)
                }
                src={row?.riderProfilePicture ?? ''}
                className="w-11 h-11 object-cover rounded-full"
              />
            </span>
            <div className={'max-w-[100%]'}>
              <span className="text-base block text-SeabiscuitDark200ThemeColor font-normal capitalize max-w-[220px] ellipsis">
                {row.riderName ?? UNKNOWN}
              </span>
              <span className={'block text-SeabiscuitDark200ThemeColor/60 text-sm'}>
                <span className={' cursor-pointer'}>
                  {row.registeredBy || row.riderName || UNKNOWN}
                </span>
              </span>
            </div>
          </Link>
        </>
      ),
      width: '20%',
    },
    {
      name: (
        <TableName
          isActive={activeSortType === ESorts.horse}
          title={'Horse & Trainer'}
          btnHandler={() => sortHandler('horseName')}
        />
      ),
      cell: (row: IRider) => {
        // Some row data literally has the horseName as "No Horse", handle appropriate styling if this is the case.
        if (row.horseName === HORSE_NAME_DEFAULT) {
          return (
            <div className={'flex items-center gap-2'}>
              <p className="text-[14px] text-SeabiscuitDark200ThemeColor/60 font-normal ">
                {HORSE_NAME_DEFAULT}
              </p>

              {!row.isScratched && (
                <ButtonSwitchHorse
                  row={row}
                  setFilteredRiders={setFilteredRiders}
                  filteredRiders={filteredRiders}
                />
              )}
            </div>
          )
        }

        if (row.horseIds && !row.horseIds[0] && row.horseName) {
          return row.horseName
        }

        const trainer = eventTrainers?.find(
          (eventTrainer) => eventTrainer.registrationByDayUniqId === row.uniqId
        )

        return (
          <div className={'flex gap-2 items-center'}>
            <span className="p-[2px] bg-[#f6f7fb] my-2 flex items-center rounded-full justify-center shrink-0">
              <img
                src={row.horseProfilePicture ?? ''}
                alt="icons"
                className="object-cover w-11 h-11 rounded-full"
                onError={(e) =>
                  ((e.target as any).src =
                    `https://ui-avatars.com/api/?name=${generateName(row.horseName ?? '')}&background=FFFFFF&format=svg&bold=true&color=BCC6D5&rounded=true`)
                }
              />
            </span>
            <div>
              <div className={'flex items-center gap-2'}>
                <div className={'flex items-center gap-1'}>
                  <span className="text-base font-normal text-SeabiscuitDark200ThemeColor">
                    {row.horseName || HORSE_NAME_DEFAULT}
                  </span>
                  <span>
                    {row.horseIds && row.horseIds.length > 1
                      ? `+${row.horseIds && row.horseIds.length - 1} horses`
                      : ''}
                  </span>
                </div>

                {!row.isScratched && (
                  <ButtonSwitchHorse
                    row={row}
                    setFilteredRiders={setFilteredRiders}
                    filteredRiders={filteredRiders}
                  />
                )}
              </div>
              <span className={'block text-SeabiscuitDark200ThemeColor/60'}>
                <p className="text-sm">{trainer?.teamMemberName || 'No trainer'}</p>
              </span>
            </div>
          </div>
        )
      },
      width: '20%',
    },
    {
      name: <TableName title={'Classes'} centered />,
      cell: (row: IRider) => (
        <>
          {!row.classes[0] || row.isScratched ? (
            <span
              className={
                'block w-[100%] md:text-center text-SeabiscuitDark200ThemeColor/60 text-[14px]'
              }
            >
              All Scratched
            </span>
          ) : (
            <span
              className={
                'block w-[100%] md:text-center text-SeabiscuitDark200ThemeColor/60 text-[14px]'
              }
            >
              {row.scratchedClasses && row.scratchedClasses.length > 0
                ? `${row.classes.length} live, ${row.scratchedClasses.length} scratched`
                : `${row.classes.length} class${row.classes.length > 1 ? 'es' : ''}`}
            </span>
          )}
        </>
      ),
      width: '10%',
    },
    {
      name: <TableName title={'Paperwork'} centered />,
      width: '10%',
      cell: (row: IRider) => {
        const isUnsigned = row.documents?.some((d) => d.status !== 'Signed')

        return (
          <>
            <div className="md:justify-center w-full flex text-[14px]">
              {isUnsigned ? (
                <span className={'text-SeabiscuitMainThemeColor'}>Unsigned</span>
              ) : (
                <span className={'text-SeabiscuitDark200ThemeColor/60'}>Signed</span>
              )}
            </div>
          </>
        )
      },
    },
    {
      name: <TableName title={'Payment'} centered />,
      cell: (row: IRider) => {
        return (
          <>
            <div className="capitalize md:justify-center w-full flex text-[14px]">
              {row?.paymentStatus === PAYMENT_STATUS.PAID ? (
                <span className={'text-SeabiscuitDark200ThemeColor/60'}>Paid</span>
              ) : (
                <span
                  onClick={() => {
                    if (row.paymentStatus !== PAYMENT_STATUS.DEFAULT) return null
                    dispatch(organizerSliceAcs.setRegistrationByDayId(row.id))
                    onViewReceiptClick(row.userId, row.registrationDocId).then()
                  }}
                  className={
                    row.paymentStatus !== PAYMENT_STATUS.DEFAULT
                      ? 'text-SeabiscuitDark200ThemeColor/60'
                      : 'cursor-pointer text-SeabiscuitMainThemeColor'
                  }
                >
                  {row?.paymentType ?? 'N/A'}
                </span>
              )}
            </div>
          </>
        )
      },
      width: '10%',
    },
    {
      name: <TableName title={'Answers'} centered />,
      cell: (row: IRider) => {
        const questionIdSet = new Set(row.answers?.map((item) => item.questionId))
        const matchingCount = EventQuestions?.filter((item) => questionIdSet.has(item.id)).length

        return (
          <div
            className={
              'text-center w-full text-SeabiscuitDark200ThemeColor/60 text-[14px] cursor-pointer hover:text-SeabiscuitMainThemeColor'
            }
          >
            <span
              onClick={() =>
                handleModalContext?.handleModal(true, MODAL_CONSTS.ANSWERS, {
                  rider: row,
                })
              }
            >
              {matchingCount || 0} answers
            </span>
          </div>
        )
      },
      width: '10%',
    },
    {
      name: <TableName title={'Manage'} centered />,
      cell: (row: IRider) => (
        <div className={'flex gap-2 md:justify-end w-[100%]'}>
          <TableBtn
            onClick={async () => {
              if (row.userId) {
                await createChatEvent(
                  [
                    {
                      id: row.userId,
                      name: row.riderName ?? '',
                      role: 'Rider',
                      vertical: 'exhibitors',
                    },
                  ],
                  eventId,
                  { eventId: eventId }
                ).then(() => {
                  window.location.href = `${window.location.href}/messages`
                })
              }
            }}
            type={'message'}
          />
          <Link
            to={`${CONST.ROUTES.MANAGE.MANAGE_RIDER.URL}/${row?.userId}/${eventId}/${row?.registrationDocId}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              if (
                (row.paymentType === PAYMENT_TYPE.DEFAULT &&
                  row.paymentStatus === PAYMENT_TYPE.DEFAULT) ||
                row.paymentStatus === PAYMENT_STATUS.PENDING
              ) {
                e.preventDefault()
                toastFunction.info({ message: MESSAGES_CONST.NOT_REGISTERED_YET })
              }
            }}
            className="hover:opacity-70 transition-all"
          >
            <TableBtn type={'go'} />
          </Link>
        </div>
      ),
      width: '12%',
    },
  ]

  const dispatch = useAppDispatch()

  useEffect(() => {
    if (EventFees) {
      const totalClassesLength = sumBy(ridersWithDraft(allRiders, false), (entry) =>
        size(entry.classes)
      )

      const allClassesLabel = {
        value: ALL_CLASSES.value,
        label: `${ALL_CLASSES.label}  <span class="text-SeabiscuitDark200ThemeColor/50">• ${totalClassesLength}  entries</span>`,
      }

      const arrClasses =
        EventFees?.registrationFees?.flatMap((itm) => {
          const classesLength = sumBy(
            ridersWithDraft(allRiders, false)?.filter((r) => r.classes.includes(itm.name || '')),
            (entry) => size(entry.classes)
          )
          if (itm.children && Array.isArray(itm.children) && itm.children.length) {
            return itm.children.map((childrenItem) => {
              const childrenClassesLength = ridersWithDraft(allRiders, false).reduce(
                (count, rider) => {
                  if (childrenItem.name && rider.classes.includes(childrenItem.name)) {
                    return count + 1
                  }
                  return count
                },
                0
              )

              return {
                value: childrenItem.name || '',
                label: `${childrenItem.name} <span class="text-SeabiscuitDark200ThemeColor/50">• ${childrenClassesLength} entries</span>`,
              }
            })
          }

          return [
            {
              value: itm.name || '',
              label: `${itm.name} <span class="text-SeabiscuitDark200ThemeColor/50">• ${classesLength} entries</span>`,
            },
          ]
        }) || []
      const newRidersClasses: typeof ridersClasses = [allClassesLabel, ...arrClasses]

      setActiveClass(allClassesLabel)
      setRidersClasses(newRidersClasses)
    }
  }, [EventFees, allRiders])

  const getSortedRiders = async () => {
    const newRiders: IRider[] = []
    const riderTeamMembers: IRiderTeamMemberInterface[] = []
    const newEventRegisteredUsers: EventRegisteredUsersModel[] = []

    try {
      dispatch(
        organizerSliceAcs.setExhibitorsAc({
          eventId,
          cursorId: null,
          tabName: 'all',
        })
      )

      const riderTeamMembersSnaps = await FirestoreService.filterItems(
        COLLECTIONS.RIDER_TEAM_MEMBER.NAME,
        [where(COLLECTIONS.RIDER_TEAM_MEMBER.FIELDS.EVENT_ID.KEY, '==', eventId)]
      )

      if (riderTeamMembersSnaps.size) {
        riderTeamMembersSnaps.forEach((currDoc) => {
          riderTeamMembers.push(
            getConvertedData(RiderTeamMemberModel.fromFirestoreDoc(currDoc).toObject())
          )
        })
      }
      const eventRegisteredUsersSnaps = await FirestoreService.filterItems(
        COLLECTIONS.EVENT_REGISTERED_USERS.NAME,
        [where(COLLECTIONS.REGISTRATION_BY_DAY.FIELDS.EVENT_ID.KEY, '==', eventId)]
      )

      eventRegisteredUsersSnaps.docs.forEach((currDoc) => {
        newEventRegisteredUsers.push(
          getConvertedData(
            EventRegisteredUsersModel.fromFirestoreDoc(currDoc).toObject()
          ) as EventRegisteredUsersModel
        )
      })

      const registeredUsersByDay = await getAllRiders([eventId])

      const newRegisteredUsersByDay = registeredUsersByDay.map((registeredUserByDay) => ({
        ...registeredUserByDay,
        riderTeamMember: riderTeamMembers.find(
          (rtm) => rtm.registrationDocId === registeredUserByDay.registrationDocId
        ),
      })) as IRegisteredUser[]

      newRegisteredUsersByDay.forEach((rider, index) => {
        const registeredUser = newEventRegisteredUsers.find((user) => rider.userId === user.userId)
        if (registeredUser) {
          newRegisteredUsersByDay[index] = {
            ...rider,
            answers: registeredUser.answers,
          }
        }
      })

      const groupedByHorseAndRider = newRegisteredUsersByDay.reduce((acc: any, item) => {
        const horseIds = item.horseIds?.join('')
        const key = `${horseIds}_${item.riderId}`

        if (!acc[key]) {
          acc[key] = { ...item, classes: [], scratchedClasses: [] }
        }
        if (item.registrationByDayName && !item.isScratched) {
          acc[key].classes.push(item.registrationByDayName)
        } else if (item.registrationByDayName && item.isScratched) {
          acc[key].scratchedClasses.push(item.registrationByDayName)
        }

        return acc
      }, {})

      newRegisteredUsersByDay.forEach((rider) => {
        const horseIds = rider.horseIds?.join('')

        let classes: string[] = []
        let scratchedClasses: string[] = []

        if (groupedByHorseAndRider[`${horseIds}_${rider.riderId}`]) {
          classes = [...groupedByHorseAndRider[`${horseIds}_${rider.riderId}`].classes]
          scratchedClasses = [
            ...groupedByHorseAndRider[`${horseIds}_${rider.riderId}`].scratchedClasses,
          ]
        }
        const isAllScratched = classes.length === 0

        const hasRider = newRiders.find(
          (rd) =>
            rd.registrationDocId === rider.registrationDocId &&
            rd.riderId === rider.riderId &&
            rd.horseIds?.join('') === horseIds
        )

        if (!hasRider) {
          const user = users.find((user) => user.id === rider.userId)
          const riderAsUserObj = users.find((user) => user.id === rider.riderId)

          newRiders.push({
            ...rider,
            riderProfilePicture: rider.riderProfilePicture || '',
            horseName: rider.horseName || '',
            horseId: rider.horseId || '',
            isScratched: isAllScratched,
            riderName: riderAsUserObj ? getUserFullName(riderAsUserObj) : rider.riderName,
            documents: [],
            registeredBy: user ? getUserFullName(user) : '',
            classes,
            scratchedClasses,
          })
        }
      })

      let documentsSnaps = await FirestoreService.filterItems(COLLECTIONS.USERS_DOCUMENTS.NAME, [
        where(COLLECTIONS.USERS_DOCUMENTS.FIELDS.EVENT_ID.KEY, '==', eventId),
      ])

      let documents = documentsSnaps.docs.map((currDoc) =>
        getConvertedData(UserDocumentModel.fromFirestoreDoc(currDoc).toObject())
      )

      // add documents to riders
      newRiders.forEach((rider) => {
        rider['documents'] = documents.filter(
          (d) => d.signatoryId === rider.riderId
        ) as UserDocumentModel[]
      })

      setAllRiders(newRiders)
      setFilteredRiders(ridersWithDraft(sortRidersByScratched(newRiders), false))
      setDraftRiders(ridersWithDraft(newRiders, true))
    } catch (error) {
      console.error(error, 'error')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (eventId) getSortedRiders().then()
    return () => {
      dispatch(organizerSliceAcs.resetExhibitorAc())
    }
  }, [eventId])

  useEffect(() => {
    let riders = ridersWithDraft(sortRidersByScratched(allRiders), false)
    let draftRiders = ridersWithDraft(allRiders, true)

    // filter by class
    if (activeClass.value !== ALL_CLASSES.value) {
      riders = riders.filter((rider) => {
        return rider.classes.includes(activeClass.value)
      })
      draftRiders = draftRiders.filter((rider) => {
        return rider.classes.includes(activeClass.value)
      })
    }

    // filter by name
    if (searchNameValue.length >= 1) {
      riders = riders.filter(
        (rider) =>
          rider.riderName?.toLowerCase().includes(searchNameValue.toLowerCase()) ||
          rider.horseName?.toLowerCase().includes(searchNameValue.toLowerCase())
      )
      draftRiders = draftRiders.filter(
        (rider) =>
          rider.riderName?.toLowerCase().includes(searchNameValue.toLowerCase()) ||
          rider.horseName?.toLowerCase().includes(searchNameValue.toLowerCase())
      )
    }

    // filter by status
    if (activeStatus.value === EStatuses.good) {
      riders = riders.filter((rider) => {
        const isUnSigned = rider.documents?.some((d) => d.status !== 'Signed')
        return rider.paymentStatus === PAYMENT_STATUS.PAID && !isUnSigned && rider.classes.length
      })
      draftRiders = draftRiders.filter((rider) => {
        const isUnSigned = rider.documents?.some((d) => d.status !== 'Signed')
        return rider.paymentStatus === PAYMENT_STATUS.PAID && !isUnSigned && rider.classes.length
      })
    } else if (activeStatus.value === EStatuses.bad) {
      riders = riders.filter((rider) => {
        const isUnSigned = rider.documents?.some((d) => d.status !== 'Signed')
        return (
          rider.paymentStatus !== PAYMENT_STATUS.PAID || isUnSigned || rider.classes.length === 0
        )
      })
      draftRiders = draftRiders.filter((rider) => {
        const isUnSigned = rider.documents?.some((d) => d.status !== 'Signed')
        return (
          rider.paymentStatus !== PAYMENT_STATUS.PAID || isUnSigned || rider.classes.length === 0
        )
      })
    } else if (activeStatus.value === EStatuses.scratched) {
      riders = riders.filter((rider) => rider.isScratched)
      draftRiders = draftRiders.filter((rider) => rider.isScratched)
    }

    setFilteredRiders(riders)
    setDraftRiders(draftRiders)
  }, [activeClass, searchNameValue, activeStatus])

  function sortHandler(type: 'riderName' | 'backNumber' | 'horseName') {
    if (activeSortType !== ESorts.none) {
      const newRiders = filteredRiders.sort((a, b) => {
        const v1 = type === 'backNumber' ? +a[type] || 0 : a[type] || ''
        const v2 = type === 'backNumber' ? +b[type] || 0 : b[type] || ''

        if (v1 < v2) {
          return -1
        }
        if (v1 > v2) {
          return 1
        }
        return 0
      })
      setFilteredRiders(newRiders)
      setActiveSortType(ESorts.none)
    } else {
      const newRiders = filteredRiders.sort((a, b) => {
        const v1 = type === 'backNumber' ? +a[type] || 0 : a[type] || ''
        const v2 = type === 'backNumber' ? +b[type] || 0 : b[type] || ''

        if (v1 > v2) {
          return -1
        }
        if (v1 < v2) {
          return 1
        }
        return 0
      })
      setFilteredRiders(newRiders)
      switch (type) {
        case 'riderName':
          return setActiveSortType(ESorts.rider)
        case 'horseName':
          return setActiveSortType(ESorts.horse)
        default:
          return setActiveSortType(ESorts.back)
      }
    }
  }

  return {
    loading,
    tableColumns,
    filteredRiders,
    draftRiders,
    allRiders,
    activeTab,
    setActiveTab,
    activeClass,
    setActiveClass,
    searchNameValue,
    setSearchNameValue,
    activeStatus,
    setActiveStatus,
    ridersClasses,
  }
}
